import React, { useState } from "react";
import FontAwesome from 'react-fontawesome';
import { withTranslation } from "react-i18next";
import {
    Dropdown, DropdownMenu, DropdownToggle
} from "reactstrap";
import { Users } from "src/sdk";

export interface DropdownUsersManagmentProps {
    values?: Users;
    onEditUser?: (values: Users) => void;
    userId?: string;
    onDeleteUser?: (userId: string) => void;
}

const DropdownUsersManagment: React.FC<DropdownUsersManagmentProps> = ({
    values,
    onEditUser,
    userId,
    onDeleteUser,
}) => {
    // Declare a new state variable, which we'll call "menu"
    const [menu, setMenu] = useState<boolean>(false);
    const [name, setName] = useState("Options");

    const editUser = () => {
        if (onEditUser) onEditUser(values as Users);
    };

    const deleteUser = () => {
        if (onDeleteUser) onDeleteUser(userId as string);
    };
    return (
        <React.Fragment>
            <Dropdown
                isOpen={menu}
                toggle={() => setMenu(!menu)}
                className="d-inline-block"
            >
                <DropdownToggle
                    className="btn header-item bg-soft-light"
                    id="page-header-user-dropdown"
                    tag="button"
                >
                    <FontAwesome name="caret-down" />
                    <span className="d-none d-xl-inline-block ms-2 me-1">{name}</span>
                </DropdownToggle>
                <DropdownMenu
                    className="dropdown-menu-end"
                    style={{ width: "150px" }}
                    container="body"
                >
                    <div className="dropdown-item" onClick={editUser}>
                        <i className="bx bx-user font-size-16 align-middle me-1" />
                        <span>Edit</span>
                    </div>
                    <div className="dropdown-item" onClick={deleteUser}>
                        <i className="bx bx-user font-size-16 align-middle me-1" />
                        <span>Delete</span>
                    </div>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

DropdownUsersManagment.propTypes = {

};
export default withTranslation()(DropdownUsersManagment);
